import {Table} from "../../../__snowpack__/pkg/antd.js";
import classNames from "../../../__snowpack__/pkg/classnames.js";
import React from "../../../__snowpack__/pkg/react.js";
const LAYOUT_HEADER_HEIGHT = 48;
const PAGE_CONTAINER_FOOTER_HEIGHT = 56;
function GnTable(props) {
  const {sticky, ...tableProps} = props;
  const footerEl = sticky && document.querySelector(".page-container-footer");
  const defaultStickyConfig = {
    offsetHeader: tableProps?.loading ? void 0 : LAYOUT_HEADER_HEIGHT,
    offsetScroll: footerEl ? PAGE_CONTAINER_FOOTER_HEIGHT : 0
  };
  return /* @__PURE__ */ React.createElement(Table, {
    ...tableProps,
    className: classNames("gn-table", props.className),
    scroll: tableProps?.dataSource?.length ? {x: "max-content", ...props.scroll} : props.scroll,
    sticky: sticky === true ? defaultStickyConfig : sticky ? {...defaultStickyConfig, ...sticky} : sticky
  });
}
GnTable.Column = Table.Column;
GnTable.ColumnGroup = Table.ColumnGroup;
GnTable.Summary = Table.Summary;
GnTable.SELECTION_ALL = Table.SELECTION_ALL;
GnTable.SELECTION_INVERT = Table.SELECTION_INVERT;
GnTable.SELECTION_NONE = Table.SELECTION_NONE;
export default GnTable;
